import { render, staticRenderFns } from "./surroundingModal.vue?vue&type=template&id=48306e38&scoped=true&"
import script from "./surroundingModal.vue?vue&type=script&lang=js&"
export * from "./surroundingModal.vue?vue&type=script&lang=js&"
import style0 from "./surroundingModal.vue?vue&type=style&index=0&id=48306e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48306e38",
  null
  
)

export default component.exports